import { defineAsyncComponent } from "vue";
/* empty css                  */
import "vuetify/components/VImg";
import "vee-validate";
import "lodash-es";
import "moment";
/* empty css                   */
import "vuetify/components";
import "vuetify";
import "../../plugins/apollo.js";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css               */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
/* empty css                               */
import "vuetify/components/VGrid";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                       */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                      */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
/* empty css                             */
/* empty css               */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                   */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                      */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                  */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                         */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                            */
import "vuetify/components/VItemGroup";
/* empty css                       */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                  */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
/* empty css                 */
/* empty css                  */
/* empty css                       */
import "vuetify/components/VLabel";
import "echarts/core";
import "echarts/renderers";
import "echarts/charts";
import "echarts/components";
import "vue-echarts";
/* empty css                    */
import "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
/* empty css                   */
import "exceljs";
import "vue3-google-map";
/* empty css              */
/* empty css                       */
import "qrcode.vue";
import "../../graphql/pages.js";
/* empty css                        */
/* empty css                  */
/* empty css                 */
import "vuetify/components/VSwitch";
import "vue3-timepicker";
import "vue3-timepicker/dist/VueTimepicker.css";
/* empty css                  */
/* empty css                  */
import { default as default2 } from "./Lazy.vue.js";
const BanzaPhoneEdit = defineAsyncComponent(
  () => import("./BanzaPhoneEdit.vue.js")
);
const BanzaXmlViewer = defineAsyncComponent(
  () => import("./BanzaXmlViewer.vue.js")
);
const BanzaJsonViewer = defineAsyncComponent(
  () => import("./BanzaJsonViewer.vue.js")
);
export {
  BanzaJsonViewer,
  BanzaPhoneEdit,
  BanzaXmlViewer,
  default2 as Lazy
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
